var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLimitations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.878,
    height: 88.91,
    viewBox: "0 0 55.878 88.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stop-svgrepo-com",
    transform: "translate(-87.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11553",
    "data-name": "Path 11553",
    d: "M143.153,60.8c.03-8.241,0-34.7,0-34.959a6.582,6.582,0,0,0-6.545-6.757h-.028a6.7,6.7,0,0,0-3.9,1.247V14.3a6.724,6.724,0,0,0-1.918-4.76,6.605,6.605,0,0,0-4.731-2H126a6.638,6.638,0,0,0-3.862,1.236V6.757A6.73,6.73,0,0,0,115.438,0h-.028a6.773,6.773,0,0,0-6.786,6.709V8.695a6.639,6.639,0,0,0-3.839-1.239h-.027a6.793,6.793,0,0,0-6.826,6.709V29.071a6.69,6.69,0,0,0-3.868-1.248h-.028a6.745,6.745,0,0,0-6.73,6.712c0,.185.032,18.579,0,26.44a1.362,1.362,0,0,0,.02.234,28.024,28.024,0,0,0,28.051,27.7A27.72,27.72,0,0,0,143.185,61.1a1.411,1.411,0,0,0-.032-.3ZM126.019,10.379a3.789,3.789,0,0,1,2.714,1.144,3.906,3.906,0,0,1,1.109,2.77V42.849l-7.7-.025V14.256A3.889,3.889,0,0,1,126.019,10.379ZM115.378,86.072A25.182,25.182,0,0,1,90.163,60.98a1.389,1.389,0,0,0-.018-.222c.03-7.99,0-26.045,0-26.22a3.894,3.894,0,0,1,7.788-.007V56.446a1.419,1.419,0,0,0,1.413,1.419,14.508,14.508,0,0,1,10.381,4.375,14.811,14.811,0,0,1,4.232,10.5,1.419,1.419,0,0,0,2.838.011,17.63,17.63,0,0,0-5.043-12.5,17.3,17.3,0,0,0-10.983-5.165V14.17a4,4,0,0,1,4-3.877,3.888,3.888,0,0,1,3.85,3.87V32.845a1.419,1.419,0,0,0,2.838,0V6.714a3.932,3.932,0,0,1,3.965-3.877A3.892,3.892,0,0,1,119.3,6.751V42.815l-7.842-.025v-4.27a1.419,1.419,0,1,0-2.838,0v4.261l-1.414,0a1.419,1.419,0,0,0-.009,2.838l23.9.076a1.433,1.433,0,0,0,.159.009,1.461,1.461,0,0,0,.153-.009l2.68.009a1.419,1.419,0,1,0,.009-2.838l-1.423,0V25.8a3.907,3.907,0,0,1,3.915-3.877,3.778,3.778,0,0,1,3.719,3.916c0,.273.032,27.4,0,35.258a1.418,1.418,0,0,0,.031.3,25,25,0,0,1-24.968,24.673Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2394",
    "data-name": "Rectangle 2394",
    width: 4,
    height: 25,
    rx: 2,
    transform: "translate(113.307 6)",
    fill: "#50fb56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2395",
    "data-name": "Rectangle 2395",
    width: 3,
    height: 15,
    rx: 1.5,
    transform: "translate(103.307 12)",
    fill: "#50fb56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2396",
    "data-name": "Rectangle 2396",
    width: 4,
    height: 15,
    rx: 2,
    transform: "translate(124.307 13)",
    fill: "#50fb56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2397",
    "data-name": "Rectangle 2397",
    width: 4,
    height: 14,
    rx: 2,
    transform: "translate(134.307 24)",
    fill: "#50fb56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2398",
    "data-name": "Rectangle 2398",
    width: 3,
    height: 12,
    rx: 1.5,
    transform: "translate(92.307 33)",
    fill: "#50fb56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitations);
export default __webpack_public_path__ + "static/media/limitations.a85b9923ecd13cafd75fd118cfe38663.svg";
export { ForwardRef as ReactComponent };